// StaticImage.js
import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { useStaticQuery, graphql } from "gatsby";

//docs:
//https://www.gatsbyjs.com/plugins/gatsby-plugin-image/
//https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-plugin-image/
const StaticImage = ({ src, className = null }) => {
  const data = useStaticQuery(graphql`
    query {
      allFile(filter: { extension: { regex: "/jpeg|jpg|png|gif/" } }) {
        edges {
          node {
            relativePath
            childImageSharp {
              gatsbyImageData(width: 800, layout: CONSTRAINED, placeholder: NONE, breakpoints: [400, 800, 1200, 1600, 2510], quality: 100)
            }
          }
        }
      }
    }
  `);

  const imageMatch = data.allFile.edges.find((edge) => edge.node.relativePath === src);

  return imageMatch ? <GatsbyImage image={getImage(imageMatch.node.childImageSharp)} alt={src} className={className} objectFit="contain" /> : null;
};

export default StaticImage;
